import {
  LOGIN,
  LOGOUT,
  SIGNUP,
  PASSWORD_RESET_INIT,
  PASSWORD_RESET_FINISH,
  CHANGE_PASSWORD
} from "./types";
import actions from "./actions";
import Vue from "vue";
import {
  errorMutations,
  loadingMutations,
  resetErrorsAndLoading,
  getter
} from "@/store/utils";

const state = {
  isLoading: false,
  errors: null,
  isAuthenticated: false,
  isAuthLoading: false
};

const getters = {
  isLoading: getter("isLoading"),
  isAuthenticated: getter("isAuthenticated"),
  isAuthLoading: getter("isAuthLoading")
};

const mutations = {
  [LOGIN.success](state) {
    Vue.set(state, "isAuthenticated", true);
    resetErrorsAndLoading(state);
  },

  [LOGOUT.request](state) {
    Vue.set(state, "isAuthLoading", true);
  },

  [LOGIN.request](state) {
    Vue.set(state, "isAuthLoading", true);
  },

  [LOGOUT.error](state) {
    Vue.set(state, "isLogoutLoading", false);
  },

  [LOGOUT.success](state) {
    Vue.set(state, "isAuthenticated", false);
    resetErrorsAndLoading(state);
  },

  [SIGNUP.success](state) {
    Vue.set(state, "isAuthenticated", true);
    resetErrorsAndLoading(state);
  },

  [PASSWORD_RESET_INIT.success](state) {
    resetErrorsAndLoading(state);
  },

  [PASSWORD_RESET_FINISH.success](state) {
    resetErrorsAndLoading(state);
  },

  [CHANGE_PASSWORD.success](state) {
    resetErrorsAndLoading(state);
  },

  ...loadingMutations([
    SIGNUP.request,
    PASSWORD_RESET_INIT.request,
    PASSWORD_RESET_FINISH.request,
    CHANGE_PASSWORD.request
  ]),
  ...errorMutations([
    LOGIN.error,
    SIGNUP.error,
    PASSWORD_RESET_INIT.error,
    PASSWORD_RESET_FINISH.error,
    CHANGE_PASSWORD.error
  ])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
